module.exports = __webpack_public_path__ + "img/icon_top_round_pre.deefb03a.png";